import {ButtonLink} from '@components/commons/button-link'
import {ChevronLeftIcon} from '@components/ui/icon'
import {AssignmentData} from '@features/assignment/components/assignment-data'
import {Steps} from '@features/assignment/components/steps'
import {getAssignmentDescription, getAssignmentSteps} from '@features/assignment/utils.tsx'
import {Assignment} from '@features/assignment/types.ts'
import {useTranslation} from '@/translations/i18n.tsx'
import {routes} from '@utilities/constants/routes.tsx'
import {useParsedLocationState} from '@hooks/useParsedLocationState.ts'
import {z} from 'zod'
import {Container} from '@components/ui/container'

export const AssignmentHero = ({assignment}: {assignment: Assignment}) => {
    const {t} = useTranslation()
    const locationState = useParsedLocationState(z.object({prevPath: z.string().optional()}))

    return (
        <section className="bg-white border-b border-neutral-300 pt-4.5 pb-8 md:pt-8 md:pb-12">
            <Container className="flex flex-col gap-12">
                <div className="flex flex-col gap-6">
                    <ButtonLink
                        className="p-0 w-max"
                        to={
                            locationState.success && locationState.data.prevPath
                                ? locationState.data.prevPath
                                : routes.HOME.handle.fullPath
                        }
                        variant="tertiary"
                    >
                        <ChevronLeftIcon />
                        {t('home:title')}
                    </ButtonLink>
                    <AssignmentData assignment={assignment} />
                </div>
                <Steps steps={getAssignmentSteps(assignment)} />
                {getAssignmentDescription(assignment)}
            </Container>
        </section>
    )
}
